import React from 'react';
import {useNavigate} from "react-router-dom";
import ListVpsUsPage from "../ListVpsUsPage";

const AdminPageListVpsUs = () => {
    const navigate = useNavigate();

    let redirectChangeUser = (listVpsId) => {
        navigate('/admin/vps-us/chuyen-khach-hang.html?' + listVpsId);
    }

    let redirectExportExcel = (listVps) => {
        navigate('/admin/vps-us/xuat-file-excel.html?' + listVps);
    }

    return <ListVpsUsPage
        redirectChangeUser={ (listVpsId) => redirectChangeUser(listVpsId) }
        redirectExportExcel={ (listVps) => redirectExportExcel(listVps) }
    />

}

export default AdminPageListVpsUs;